<!-- NEWDESIGN DONE -->
@if (cookiesService.showCookies) {
<!-- nnkitodo [newdesign] à changer en bg-v2-blueRibbon-950/40 => mais le background opacity n'arrive pas à s'appliquer surement à cause du format de la variable -->
<div class="fixed z-cookies bg-v2-black/60 inset-0">
  <div class="absolute inset-0 top-auto bg-v2-theme-white pb-safeBottom pr-safeIntercom">
    <div class="container-xl grid grid-cols-1 sm:grid-cols-[auto_256px] gap-8 py-8">
      <div class="grid grid-cols-1 gap-8">
        <app-site-logo />
        <div class="grid grid-cols-1 gap-2">
          <p i18n="@@cookies.consent_notice" class="text-base"
            >{{ languageService.siteName }} et ses partenaires utilisent des cookies et des
            identifiants publicitaires mobiles pour mesurer l'audience, pour la personnalisation des
            annonces et pour diffuser des annonces personnalisées et non personnalisées. Vous
            pourrez à tout moment modifier votre choix depuis les paramètres.</p
          >
        </div>
      </div>

      <div class="flex flex-col justify-start h-full gap-4">
        <app-button
          i18n="@@utils.accepter"
          [fullWidth]="true"
          (click)="cookiesService.acceptCookies()"
          >Accepter</app-button
        >

        <app-button
          i18n="@@cookies.necessaires"
          color="white/primary"
          [withBorder]="true"
          [fullWidth]="true"
          (click)="cookiesService.refuseCookies()"
          >Cookies nécessaires uniquement</app-button
        >

        <a
          i18n="@@cookies.savoir_plus"
          [routerLink]="['/legal/confidentiality']"
          class="ml-auto mt-auto text-xs cursor-pointer"
          >En savoir +</a
        >
      </div>
    </div>
  </div>
</div>
}
